import { RouteComponent, RouteLocationNormalizedLoaded, RouteRecordRedirectOption } from 'vue-router'
import { promiseFunction } from 'complex-data/src/data/BaseData'
import { upperCaseFirstChar } from 'complex-utils'
import { VNode } from 'vue'

export type statusType = 'un' | 'ing' | 'end'

export type menuTypeDict = 'router' | 'url'

export interface originMenuType {
  path: string
  name: string | ((route?: RouteLocationNormalizedLoaded) => string)
  component?: RouteComponent
  redirect?: RouteRecordRedirectOption
  type?: menuTypeDict
  title?: string
  icon?: () => VNode
  menu?: boolean
  keepAlive?: boolean
  internalOrExternal?: boolean
  hidden?: boolean
  tab?: 'hidden'
  tile?: boolean
  role?: string[]
  unauthorized?: boolean
  developing?: boolean
  children?: originMenuType[]
}

export interface menuType {
  path: string
  name: string
  redirect?: RouteRecordRedirectOption
  component?: RouteComponent
  children?: menuType[]
  meta: {
    name: string | ((route?: RouteLocationNormalizedLoaded) => string)
    type: menuTypeDict
    keepAlive?: boolean
    internalOrExternal?: boolean
    tile?: boolean
    title?: string
    icon?: () => VNode
    menu?: boolean
    hidden?: boolean
    tab?: 'hidden'
    unauthorized?: boolean
    developing?: boolean
  }
}

export interface MenuDataInitOption {
  $getData: promiseFunction
  $addRouter: () => void
}

class MenuData {
  load: statusType
  list: menuType[]
  menu: menuType[]
  current: string[]
  collapsed: boolean
  $getData: promiseFunction
  $addRouter: () => void
  constructor(initOption: MenuDataInitOption) {
    this.load = 'un'
    this.list = []
    this.menu = []
    this.current = []
    this.collapsed = false
    this.$getData = initOption.$getData
    this.$addRouter = initOption.$addRouter
  }
  $loadData() {
    if (this.load === 'end') {
      return Promise.resolve({ status: 'loaded' })
    } else {
      return new Promise((resolve, reject) => {
        this.load = 'ing'
        this.$getData().then(() => {
          this.$addRouter()
          this.menu = this.$formatMenu(this.list)
          this.load = 'end'
          resolve({ status: 'success' })
        }).catch(err => {
          // eslint-disable-next-line no-console
          console.error(err)
          this.load = 'un'
          reject(err)
        })
      })
    }
  }
  $formatData(menuList: originMenuType[], deep = 0) {
    const list: menuType[] = []
    menuList.forEach((menuItem) => {
      const nameList = menuItem.path.split('/')
      nameList.shift()
      const item: menuType = {
        path: menuItem.internalOrExternal ? '$url:' + 'https:/' + menuItem.path : menuItem.path,
        name: nameList.map(nameItem => upperCaseFirstChar(nameItem)).join(''),
        redirect: menuItem.redirect,
        component: menuItem.component,
        children: menuItem.children ? this.$formatData(menuItem.children, deep + 1) : undefined,
        meta: {
          name: menuItem.name,
          type: menuItem.type === undefined ? 'router' : menuItem.type,
          tile: !!menuItem.tile,
          title: menuItem.title,
          icon: menuItem.icon,
          menu: menuItem.menu === undefined ? true : menuItem.menu,
          keepAlive: menuItem.keepAlive,
          internalOrExternal: menuItem.internalOrExternal,
          hidden: menuItem.hidden,
          tab: menuItem.tab,
          unauthorized: menuItem.unauthorized,
          developing: menuItem.developing
        }
      }
      if (item.meta.type !== 'router') {
        item.path = '$' + item.meta.type + ':' + item.path
      }
      if (menuItem.role) {
        list.push(item)
      } else {
        list.push(item)
      }
    })
    return list
  }
  $formatMenu(menuList: menuType[]) {
    const list: menuType[] = []
    for (let i = 0; i < menuList.length; i++) {
      const menuItem = menuList[i]
      if (menuItem.meta.menu && !menuItem.meta.hidden) {
        const item = {
          ...menuItem
        }
        let children: undefined | menuType[]
        if (menuItem.children && menuItem.children.length > 0) {
          children = this.$formatMenu(menuItem.children)
        }
        if (children && children.length > 0) {
          item.children = children
          if (item.meta.tile) {
            for (let n = 0; n < children.length; n++) {
              const child = children[n]
              list.push(child)
            }
          } else {
            list.push(item)
          }
        } else {
          list.push(item)
        }
      }
    }
    return list
  }
  setCurrent(item: menuType) {
    if (item.meta.type === 'router') {
      this.current = [item.path]
    } else if (item.meta.type === 'url') {
      // openWindow(item.path)
    }
  }
  reset() {
    this.load = 'un'
    this.list = []
    this.menu = []
    this.current = []
  }
}

export default MenuData
